module.exports = __webpack_public_path__ + "img/NSpearman64_ua.822a0e68.webp";